export const PATHS = {
  BASE: '/',
  LOADING: 'loading',
  HOME: 'home',
  FAQ: 'faq',
  SIGNUP: 'signup',
  UNSUPPORTED: 'unsupported',
}

export const APP_STATES = {
  // loading states
  LOADING: 'loading',
  LANDING: 'landing',

  // home states
  HOME: 'home',
  HOME_WELCOME: 'welcome',
  HOME_EPOCH_ONE: 'epoch-one',
  HOME_EPOCH_TWO: 'epoch-two',
  HOME_EPOCH_THREE: 'epoch-three',
  HOME_EPOCH_FOUR: 'epoch-four',
  HOME_CTA: 'cta',
  //HOME_FOOTER: 'footer',

  // other
  //UNSUPPORTED: 'unsupported',
  FAQ: 'faq',
  SIGNUP: 'signup',
}

export const HOME_STATES = [
  APP_STATES.HOME_WELCOME,
  APP_STATES.HOME_EPOCH_ONE,
  APP_STATES.HOME_EPOCH_TWO,
  APP_STATES.HOME_EPOCH_THREE,
  APP_STATES.HOME_EPOCH_FOUR,
  APP_STATES.HOME_CTA,
]

export const MODAL_STATES = {
  NONE: 'MODAL_STATE:NONE',
  MENU: 'MODAL_STATE:MENU',
  LOADING: 'MODAL_STATE:LOADING',
}

export const LOAD = {
  GROUPS: {
    CRITICAL: 'LOAD:GROUPS:CRITICAL',
    MAIN: 'LOAD:GROUPS:MAIN',
    EPOCH_1: 'LOAD:GROUPS:EPOCH_1',
    EPOCH_2: 'LOAD:GROUPS:EPOCH_2',
    EPOCH_3: 'LOAD:GROUPS:EPOCH_3',
    EPOCH_4: 'LOAD:GROUPS:EPOCH_4',
  },
  STATES: {
    // FRAMEWORK - Bootstrap app
    FRAMEWORK_LOADING: 'LOAD:STATES:FRAMEWORK_LOADING',
    FRAMEWORK_LOADED: 'LOAD:STATES:FRAMEWORK_LOADED',

    // CRITICAL - Initial Assets needed first fold / loading et al
    CRITICAL_LOADING: 'LOAD:STATES:CRITICAL_LOADING',
    CRITICAL_LOADED: 'LOAD:STATES:CRITICAL_LOADED',

    // MAIN - Sundry Assets
    MAIN_LOADING: 'LOAD:STATES:MAIN_LOADING',
    MAIN_LOADED: 'LOAD:STATES:MAIN_LOADED',

    // LOAD COMPLETE
    COMPLETE: 'LOAD:STATES:COMPLETE',
  },
}

export const EVENTS = {
  RESIZE: 'EVENTS:RESIZE',
  SCROLL: {
    LOCK: 'EVENTS:SCROLL:LOCK',
    UNLOCK: 'EVENTS:SCROLL:UNLOCK',
    SET: 'EVENTS:SCROLL:SET',
  },
  STOP_RENDER: 'EVENTS:STOP_RENDER',
  START_RENDER: 'EVENTS:START_RENDER',
  MOUSE_ENTER: 'EVENTS:MOUSE_ENTER',
  MOUSE_LEAVE: 'EVENTS:MOUSE_LEAVE',
  SECTION: {
    SCROLL_RATIO: 'EVENTS:SECTION:SCROLL_RATIO',
    RECT: 'EVENTS:SECTION:RECT',
  },

  // defined in vue.config
  PRE_RENDER_HTML: window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.EVENTS.PRE_RENDER_HTML,
}
